import React from "react";
import { toast } from "react-toastify";
import { PaystackButton } from 'react-paystack';
import { verifyPayment } from "../../services/paymentService";


const PaystackBtn = ({ data, publicKey, onRefresh }) => {

  const config = {
    reference: data.transid,
    email: data.email,
    amount: data.amount * 100, // Amount in kobo
    publicKey: publicKey,
  };

  // Add subaccount code if provided (for split payments)
  if (data.subaccountCode) {
    config.subaccount = data.subaccountCode;
    
    // Handle different split types
    if (data.splitType === 'flat' && data.splitAmount) {
      // For flat fees: platform gets (total - reseller_share)
      const platformShare = Math.max(0, data.amount - data.splitAmount);
      config.transaction_charge = platformShare * 100; // Convert to kobo
    }
    // For percentage splits: Paystack handles it automatically via subaccount percentage_charge
    // No additional config needed - the percentage is set in the subaccount configuration
  }

  const handlePaystackSuccessAction = async (reference) => {

    const response = await verifyPayment(reference);

    if (response.data.verified === true) {
      toast.success("Transaction successful!");
      if (onRefresh) onRefresh(reference.reference);
    } else {
    toast.error("Could not verify transaction!");
    }
  };

  const handlePaystackCloseAction = () => {
    // Dialog closed Action
    toast.info("Transaction closed!");
    return
  }

  const componentProps = {
    ...config,
    children: [<i key="1" className="fa fa-credit-card" aria-hidden="true" />, ' Pay Now!'],
    className: 'btn btn-outline-success btn-sm',
    onSuccess: (reference) => handlePaystackSuccessAction(reference),
    onClose: handlePaystackCloseAction,
  };

  return (
    <PaystackButton {...componentProps} />
  )
};

export default PaystackBtn;
